exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-microcart-icon[data-v-07b9e3a9]{position:relative}.a-microcart-icon .sf-header__icon[data-v-07b9e3a9]{cursor:pointer}\n", ""]);

// exports
